<div class="report-details__wrapper">
  <div *ngIf="loading" class="loading">
    <mat-spinner />
  </div>
  <div class="report-details" id="content" #content>
    <div class="report-details__breadcrumbs-container">
      <a class="report-details__breadcrumb mat-typography" [routerLink]="'/analytic/operations'">Operations</a>
      <mat-icon>chevron_right</mat-icon>
      <span class="report-details__breadcrumb mat-typography">Report Details</span>
    </div>
    <app-user-details [userDetails]="userDetails"></app-user-details>
    <div class="report-details__select">
      <mat-form-field appearance="outline">
        <mat-select [(ngModel)]="numberOfDays" (selectionChange)="onNumberOfDaysChanged()">
          <mat-option *ngFor="let option of numberOfDaysOptions" [value]="option.value">
            {{ option.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <app-citation-details [details]="combineCitationDetails"></app-citation-details>

    <div class="report-details__map-title">Last 25 Citation Locations</div>
    <div class="report-details__map-container" id="mapContainer" #mapContainer></div>
  </div>
</div>
